import { gql } from '@apollo/client';

const ONGOING_STUDY_COUNT_QUERY = gql`
  query ongoingStudyCount($filter: OngoingStudyCountFilterInput) {
    ongoingStudyCount(filter: $filter)
  }
`;

export default ONGOING_STUDY_COUNT_QUERY;
